import { useContext, useMemo, useCallback } from 'react';
import moment from 'moment';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const useShiftDateColumn = ({ nextToName = false } = {}) => {
  const { t, isRtl, dateFormat } = useContext(ConfigContext);

  const valueGetter = useCallback(
    (params) => {
      if (params.node?.group) return null;
      return nextToName ? params.data?.date : params.data?.scheduleIn;
    },
    [nextToName]
  );

  const valueFormatter = useCallback(
    (params) => {
      if (!params.value) return '';
      return moment(params.value).format(dateFormat);
    },
    [dateFormat]
  );

  return useMemo(
    () => ({
      colId: nextToName ? 'shift-date-next-to-name' : 'shift-date',
      field: 'scheduleIn',
      headerName: t('shiftDate'),
      cellClass: nextToName ? 'justify-start' : 'justify-center',
      ...(nextToName ? {} : { initialHide: true }),
      ...(nextToName ? { pinned: isRtl ? 'right' : 'left' } : {}),
      suppressColumnsToolPanel: nextToName,
      width: 140,
      ...(valueGetter ? { valueGetter } : {}),
      valueFormatter
    }),
    [t, valueGetter, valueFormatter, nextToName, isRtl]
  );
};

export default useShiftDateColumn;
